module.exports = __webpack_public_path__ + "img/[合十].8ec037d5.svg";